import { render, staticRenderFns } from "./RequestDetailConfirmation.vue?vue&type=template&id=23106326&"
import script from "./RequestDetailConfirmation.vue?vue&type=script&lang=js&"
export * from "./RequestDetailConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports